<!--
 * @Author: MX
 * @Date: 2021-06-03 14:22:32
 * @Description:
-->
<template>
  <div class="privacyWrapper">
    <p class="title">
      {{$lang('极兔国际App隐私政策-欧盟')}}
    </p>

    <div class="content-wrapWrapper">
      <p class="depData">发布日期：2021年xx月xx日</p>
      <p class="effDate">生效日期：2021年xx月xx日</p>
      <div class="content-wrap">
        <p class="chapter">
          上海极兔速递有限公司（以下简称“极兔”或“我们”）在您与我们分享您的个人信息时，我们始终尊重您的隐私并重视您对我们的信任。本隐私政策（以下简称“本政策”）阐述了我们如何收集，持有，使用，披露和以其他方式处理您的个人信息，我们为何以及基于何种法律依据处理您的个人信息，与谁以及出于什么目的共享您的个人信息，以及您对我们使用您的个人信息享有的权利和选择权。本政策适用于我们在以下情况下使用您的个人信息：当我们向您或您的单位提供产品和/或服务；当您使用我们的官方网站或国际件下单系统（JMS）网站（以下简称“网站”），我们的移动应用程序（xxxAPP），以及我们运营的任何其他渠道或移动功能；当您向我们下订单，或以其他方式与我们联系；以及当您购买服务并与我们进行线下互动（以下统称“服务”）。 如果以上任何一种情况适用于您，请仔细阅读本政策。极兔将在网站显示本政策或本政策的链接。
        </p>
        <p class="chapter">
          当我们在本政策中提到“您”时，其包括您和/或您的单位。
        </p>
        <p class="chapter">
          上海极兔速递有限公司、极兔速递（XXX国家）有限公司、深圳云路信息科技有限责任公司（如有其他相关公司请补充），是处理您的个人信息的数据控制者。这些公司的联系方式请见本政策的附件1。/或您的单位。
        </p>
        <p class="chapter">
          上海极兔速递有限公司、极兔速递（XXX国家）有限公司、深圳云路信息科技有限责任公司（如有其他相关公司请补充）在为您提供我们的服务时所进行的处理活动中是共同数据控制者，这意味着他们可以共同确定处理您的个人数据的目的和方式。/或您的单位。
        </p>
        </br>
        <p class="title">儿童</p>
        <p class="chapter">
          我们不会有意收集18周岁以下儿童的信息，我们的服务也不针对他们。如果您未满18周岁，请不要向我们提交任何个人信息或注册使用我们的服务。如果您希望使用我们的服务，请寻求您的父母或监护人的帮助。
        </p>
        <p class="chapter">
          如果您（作为对孩子负有父母责任的人）发现您的孩子未经您的同意向我们提供了个人信息，请联系我们，如有需要，我们将删除这些个人信息。
        </p>
        <a href="#useage">
          数据的收集、使用
        </a>
        <a href="#eligle">
          数据处理的法律依据
        </a>
        <a href="#require">
          法律和其他要求
        </a>
        <a href="#overdate">
          数据的存储期限
        </a>
        <a href="#share">
          数据的共享和披露
        </a>
        <a href="#transfer">
          数据的跨境转移
        </a>
        <a href="#rights">
          信息主体的权力
        </a>
        <a href="#private">
          如何保护您的个人信息
        </a>
        <a href="#update">
          本隐私政策的更新
        </a>
        <a href="#contact">
          如何联系我们
        </a>
        <p class="title" id="usage">一、数据的收集、使用</p>

        <p class="chapter">
          1、我们可能会在下列活动中，获得您的个人信息：
        </p>
        <p class="chapter">
          a)由您提供（例如通过我们的网站/您使用我们的服务）；
        </p>
        <p class="chapter">
          b)从公开来源（例如互联网、公司注册机关）取得；
        </p>
        <p class="chapter">
          c)直接或间接来自于网站上的活动。例如，自动收集的网站使用细节。此外，与许多组织一样，我们使用“Cookies”，这是一种小型文本文件，网站可以使用它来识别重复用户，方便用户持续访问和使用网站，并跟踪使用行为，例如，您访问的网页。
        </p>
        <p class="chapter">
          d)来自协助我们提供某些交易和服务的战略商业伙伴（例如授权经销商、可能代表我们收取您的包裏的授权业务伙伴……）。
        </p>

        <p class="chapter">
          a)用于开展我们的业务；
        </p>
        <p class="chapter">
          b)用于允许访问和使用我们的移动应用程序（以下简称“应用程序”）；
        </p>
        <p class="chapter">
          c)用于履行我们的法律义务；
        </p>
        <p class="chapter">
          d)用于实现我们在收集您的个人信息时向您阐明的目的；
        </p>
        <p class="chapter">
          e)用于实现本节中进一步详细阐明的其他目的；和
        </p>
        <p class="chapter">
          f)用于……
        </p>
        <p class="chapter">
          2、我们将收集、存储并使用您的个人信息：
        </p>
        <p class="chapter">
          以下我们列举了我们可能收集或接收的信息的类型，我们将如何使用这些信息，以及为什么使用这些信息。
        </p>
        <p class="chapter">
          a)账号注册：为完成我们网站上的账户创建，我们需要您提供以下信息（以下统称“账户信息”）：您的手机号、电子邮箱地址、账户名称和账户密码。我们将通过电子邮件发送验证码来验证您的身份。
        </p>
        <p class="chapter">
          b)物流服务（包括清关）：在您下单寄件或您的信息作为收件人被提供时，极兔（或极兔授权的业务合作伙伴）将收集您的信息用于以下目的：(i)提交快件订单；(ii)生成包裹标签；(iii)生成形式发票；(iv)追踪包裹运送状态；(v)进行出口清关；(vi)进行进口清关；和(vii)在中国境内投递快件。为此，我们将处理的个人信息包括：
        </p>
        <p class="chapter">
          a.收件人和寄件人的姓名、地址和联系方式；
        </p>
        <p class="chapter">
          a.收件人和寄件人的姓名、地址和联系方式；
        </p>
        b.快件运输信息（以下简称“运单信息”）（我们使用这些信息以提交订单，生成物流运单，取件，分类，存储和运输快件，进行进出口清关并投递快件）；
        c.在法律允许或要求的情况下，收集您的身份证件以核实您的身份并进行进出口报关；
        d.您在向我们投诉或提出请求时可能提供给我们的您的姓名，联系方式以及任何其他信息（请注意，如果您致电我们的呼叫中心或通过电话与我们联系，我们可能会对电话进行录音，以管理和/或避免任何潜在纠纷;
        e.如果您提供了不准确或不完整的投递地址，在不违反相关法律法规的前提下，我们可能会使用您过往的运单信息对不准确、不完整的地址信息进行补全、纠正，以节省与收件人/寄件人反复确认地址的时间，保证时效（避免您因快件错误派送和/或延迟派送而遭受损失，让您有更好的服务体验）。
        c)支付明细：如果您想收到我们的服务的发票，我们还将收集以下信息：发票抬头、纳税人识别号、收票人电子邮箱地址，以及您根据您的开票需求提供的更多信息，如购买方信息。
        d)消息推送：我们将收集您的设备信息，用于向您推送快件运送路线信息、支付状态信息以及xxx信息（补充可能收集的其他信息）。您可以在您的手机或其他设备的“设置”中，或在应用程序、微信公众号上启动“免打扰”设置（如无免打扰功能，可根据实际可关闭信息收集的类似设置进行修改）。
        e)客户服务和售后服务：我们的客户服务和售后服务代表可能会使用您的帐户信息和运单信息，这是为了保证您的帐户安全。我们的呼叫中心和在线客服代表（如无客服呼叫中心此处请根据实际情况修改），将使用您的帐户信息和运单信息以验证您的身份。如果您希望我们就所提供的服务，向您提供客户服务和/或售后服务，我们将要求您提供运单信息和快件运送路线信息。为了回复您的咨询，我们可能还会要求您提供所需的其他信息。
        f)改进我们的产品或服务：根据您的帐户信息和运单信息，我们可能会创建用户画像，用于为您提供个性化服务，并向您发送您可能感兴趣的服务信息（如无推送服务信息可删除此句描述）。在适当的情况下，我们可能会关联从您的各种设备上收集到的信息，以改善我们的服务（例如，确保我们通过多种设备给您提供的服务是一致和/或互补的）。为了向您提供个性化服务并提升服务水平（包括改进快递收件/派送服务以及客户的整体体验），在相关法律允许的情况下，我们也可能对所收集的您的信息进行整合和数据分析，这些信息来自(i)您对我们的服务的使用；或(ii)公开的渠道（例如政府官方网站（如工商部门、交通运输部门、税务部门、法院））。……
        g)安全性：在相关法律允许和/或要求的情况下，为了确保我们系统的安全性（例如，防止任何网络钓鱼攻击，保护您的帐户安全），我们可能会处理您的浏览器信息、URL、运单信息以及您使用的软件或设备的信息。当您到访我们的营业场所时，我们还会通过我们的安全系统（例如，视频监控系统）收集您的信息。
        h)匿名化：根据相关法律，我们可能会对您的个人数据进行匿名化、汇总或其他方式去识别化（即不再能够识别您的身份），以进行数据分析、统计研究并帮助我们了解我们如何改善我们的服务。
        二、数据处理的法律依据
        为了处理您的个人数据，我们需要法律依据。我们进行数据处理的法律依据取决于数据处理的目的。每当我们收集或以其他方式处理您的个人数据时，我们都将基于以下法律依据：
        a) 在法律要求的情况下，您对此类收集和处理的同意（例如，我们可能需要您的同意，以处理您的个人信息，用于直接营销活动或使用cookies等技术）；
        b) 为履行与您所达成的合同的必要，例如您接受的用户协议以及其他协议；
        c) 为了我们的合法商业利益，在任何情况下，我们都会在处理目的之必要性与您的隐私和保密权益之间做出权衡，包括考虑您的合理期待、处理影响和已经或可以采取的安全措施。在任何情况下，为了我们的合法商业利益，我们都将把数据处理限制在必要的目的范围内。当我们出于合法商业利益目的处理个人数据时，这些利益包括：
        a.提升我们的服务，以及改善您与我们互动时的体验；
        b.开发和增强产品，即数据处理使我们能够增强、调整、定制或以其他方式改善我们的服务和沟通，以惠及我们的客户，并更好地了解用户如何使用我们的服务；
        c.基于行政目的和其他合法商业目的在组织内部进行转移；
        d.检测和预防欺诈；
        e.进行辩护或提出法律主张；
        f.增强我们、我们的员工以及第三方（例如访客）的安全性（包括改善我们的网络和信息系统安全性在内的网络安全）；
        g.一般的业务运营和尽职调查工作（例如，与供应商、合作伙伴和其他组织建立和维持关系，以及与其员工进行的往来）； 和
        h.为您提供我们的服务。
        为了符合法律义务所必需，例如与税务相关的法定保存期限、响应政府机关的要求（如司法机关）以及海关部门的清关要求。
        如果您想了解更多关于我们处理您的个人信息的合法利益的信息，请联系我们。
        我们不会做出对您有重大法律影响的自动决策。但是，如果这种情况在未来发生变化，我们将确保此类决策符合适用法律，并确保您被告知此类决策符合适用法律。
        三、法律和其他要求
        如上所述，我们要求的某些个人信息是提供服务所必需的，如果不提供这些信息，我们可能无法向您提供相关服务或提供您要求我们提供的信息。
        如果执法或监管部门、团体或机构提出合理要求，或者为了调査、防止或采取有关涉嫌非法活动或欺诈的行动，为了执行或适用我们的用户协议和其他协议，为了保护公司、消费者、客户和其他人的权利、财产或安全，或者为了维护法律主张，我们也可能会处理您的个人信息。如果与调查或纠纷有关，或直到适用法律允许删除之前，我们不会删除个人信息。在这些问题完全解决并可以合法删除之前，我们将继续保留这些信息。
        您通过我们的网站向我们提供的任何个人信息必须是完整和准确的。请注意，如有需要，我们可以与您联系以核实您的个人信息。
        四、数据的存储期限
        我们保存您的个人数据的期限为我们收集此信息用于包含为了满足法律、会计或报告要求以及实现极兔合法的商业利益所需要的必要时间。
        如您的个人信息不再需要用于上述目的，我们将删除您的个人信息。
        在某些情况下我们可能会匿名处理您的个人信息以便此数据不再与您相关联，在此种情况下我们可能使用此类数据而不另行通知您。
        五、数据的共享和披露
        1、在某些情况下，我们会将您的个人信息传输给第三方，例如我们的服务提供商、关联公司和执法机构。这些情况包括：
        a)我们与我们集团的其他成员公司共享您的信息，以便我们能够在集团内提供最佳服务。其必须按照本政策的要求保存和使用您的信息。
        b)我们与我们的授权业务伙伴、经销商、某些承包商或服务提供商（例如数据处理者）共享您的信息。他们可能会为我们处理您的个人信息，例如，如果我们使用云服务提供商（例如阿里云）。其他服务供应商包括xxxx（如IT供应商、备份和灾难恢复专家、电子邮件供应商和外包呼叫中心）。我们的供应商和服务提供商将被要求符合我们处理信息和安全的标准。我们向其提供的信息，包括您的信息，将仅在他们履行职能时提供。其不得将您的信息用于本政策所述以外的任何目的。
        c)我们可能会将您的信息与支付处理机构共享。当您下单时，您可以选择极兔的相关方或与极兔合作的任何第三方支付机构（例如支付宝、微信支付、银联、网联，以下统称“支付机构”）提供的支付服务，我们将向这些支付机构提供您的极兔订单号和交易金额信息，以确认您的支付指令并完成支付。
        d)为完成领取和交付货物的服务，我们可能与寄件人、收件人、第三方付款人和接收人等第三方共享货运信息。
        e)其他因提供极兔产品或服务或因法律规定，而必须向第三方共享个人信息的情况下，我们可能与该第三方共享信息。
        f)……
        2、此外，我们可能在以下情况下披露您的相关信息：
        a)如果法律要求我们这样做，或我们遵循的任何监管规则或惯例，或任何公共或监管机构（例如警方或海关当局）要求我们这样做；
        b)如果我们对法律索赔进行辩护，您的信息可能会被传输至与该索赔相关的地方。
        c)我们保留在出售或转让所有或部分自身业务或资产时（包括在重组、解散或清盘时）一并转让与您相关的信息的权利。
        如果您的个人信息被匿名化和汇总，您的个人信息可能会被共享，因为在此情况下，这些信息将不再属于个人信息。
        六、数据的跨境转移
        我们可能会将有关您的个人信息传送到信息原始收集国以外的国家。该等国家可能并未设立与信息原始收集国一样的数据保护法律。当我们将您的信息传送至欧盟之外的国家时，我们会依据适用法律的规定采取相关措施保护该等信息。
        七、信息主体的权力
        依照欧盟适用的法律，您有权访问数据、更正数据、删除数据、限制对数据的处理、移植数据且有权反对。请注意：大部分权利是不绝对的且在法律中受豁免，可能仅适用于某些类型的信息或处理。在如下部分，我们将更加详细地列举您的权利并提供您如何行使权利的信息。我们会在一个月内回应您的请求且有权将此期限延长至两个月。如我们要延长回应期限，我们会在自您提出请求的一个月内告知您。
        a)访问：您有权查询我们是否在处理您的信息，如果是，您可以要求访问您的个人信息。您可以收到我们所持有的您的个人信息的副本以及某些其他相关信息；
        b)更正：您有权要求我们更正我们所持有的关于您的任何不完整或不准确的个人信息；
        c)删除：在某些情况下，您有权要求我们删除或移除个人信息。在某些例外情况下，我们可能会拒绝删除请求，例如，为了遵守相关法律或应对相关索赔；
        d)限制：您有权要求我们暂停处理您的某些个人信息，例如，如果您希望我们确定其准确性或处理的原因；
        e)传输：您可以要求我们将您的某些个人信息传输至另一方；
        f)异议：当我们基于合法利益（或第三方的利益）处理您的个人信息时，您可以对此提出异议。但是，我们可能有权基于我们的合法利益或在与法律索赔相关的情况下继续处理您的信息。如果我们为直接营销目的处理您的个人信息，您也有权提出异议；
        g)同意：如果我们基于同意处理个人信息，您可以撤回您的同意。
        您还有权向监管机构提出投诉，涉嫌违反数据保护法的行为的发生地所在的欧盟成员国。
        八、如何保护您的个人信息
        我们会在管理、技术、组织和物理上采取一切合理措施，以保护您所提供的个人信息，使其免受意外、非法或未经授权的破坏、损失、更改、存取、披露或使用。尽管我们采取相应的安全措施来保护您的信息，但请您理解任何安全措施都不是无懈可击的。
        九、第三方网站链接
        我们的网站和其他通信可能会不时包含其他网站的链接，包括提供给您并由您的浏览器支持的我们的合作伙伴网络、广告服务商和其他集团公司和/或社交网络的网站。
        您通过这些网站提供的个人信息不受本政策的约束，我们亦不对这些网站对您的个人信息的处理负责。如果您通过链接进入这些网站，请注意这些网站有自己的政策，其中将说明在访问这些网站时其如何收集和处理您的信息。关于与社交分享功能有关的数据收集和处理的目的和范围的更多信息，请访问您选择分享的实体的政策。
        十、本政策的更新
        本政策可能不时变更。
        如果我们变更了有关本政策的任何重要内容（我们收集的信息、使用方式或原因），我们将在本政策的顶部突出显示这些变更，并在变更后的合理时间内提供一个显著的链接。
        本政策一经在我们的网站上发布将自动生效。本政策的最新版本将优先于之前的所有版本。
        十一、如何联系我们
        如果您就个人信息安全方面有任何投诉或对本政策有任何疑问、意见或建议，可通过以下方式联系我们。我们我们将在合理期限内向您作出答复、解释或跟进。
        电子邮箱地址：xxxx，
        客服电话：，
        地址：xxxxx。
        附件 1
        本政策涉及的数据控制者的联系方式
        上海极兔速递有限公司
        地址：上海市青浦区华新镇华隆路1777号
        官方邮箱：jtservice@jtexpress.com.cn
        客服电话：400-820-1666
        极兔速递（XXX国家）有限公司
        地址：
        官方邮箱：
        客服电话：
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy',

}
</script>

<style lang="scss" scoped>
  .privacyWrapper{
      height: 800px;
      overflow-y: scroll;
    .title{
      font-size: 16px;
      font-family: PingFang, PingFang-SC;
      font-weight: SC;
      text-align: left;
      color: #2b2d42;
      line-height: 20px;
      border-bottom: 1px dashed #c4c8cc;
    }

  }
</style>>
